import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let refreshing = null;
api.interceptors.response.use(null, async (err) => {
  const cfg = err.config || {};
  const url = cfg.url || "";
  if (err.response?.status !== 401 || cfg._retried || /auth\/(login|refresh|logout|register)/.test(url)
      || localStorage.getItem("gk_auth") !== "1") throw err;
  cfg._retried = true;
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  try { await refreshing; } catch (e) { throw err; }
  return api(cfg);
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
